import React, { useState } from 'react';
import { Button, Form } from "react-bootstrap";
import { IoMdDownload } from "react-icons/io";
import kmlIcon from "../../../picture/kml-file.png"
import geojsonIcon from "../../../picture/kml-file.png"
function ExportKMLButton(props) {
    const [selectedValue, setSelectedValue] = useState("");
  const exportKML = () => {
    const coordinates = props.positions;

    let kmlCoordinates = "";
    coordinates.forEach((coord) => {
      kmlCoordinates += `${coord.Lon},${coord.Lat} `;
    });

    kmlCoordinates = kmlCoordinates.trim();

    const kml = `<?xml version="1.0" encoding="UTF-8"?>
        <kml xmlns="http://www.opengis.net/kml/2.2">
          <Document>
            <Placemark>
              <Polygon>
                <outerBoundaryIs>
                  <LinearRing>
                    <coordinates>
                      ${kmlCoordinates}
                    </coordinates>
                  </LinearRing>
                </outerBoundaryIs>
              </Polygon>
            </Placemark>
          </Document>
        </kml>`;

    const downloadKML = (kmlContent, filename) => {
      const blob = new Blob([kmlContent], {
        type: "application/vnd.google-earth.kml+xml",
      });
      const a = document.createElement("a");
      const url = URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
      a.remove();
    };

    downloadKML(kml, "coordinates.kml");
    navigator.clipboard.writeText(kml);
  };

  const exportGeoJSON = () => {
    const geoJson = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [
              props.positions.map((coord) => [coord.Lon, coord.Lat]),
            ],
          },
          properties: {},
        },
      ],
    };

    const downloadGeoJSON = (geoJsonContent, filename) => {
      const blob = new Blob([JSON.stringify(geoJsonContent)], {
        type: "application/json",
      });
      const a = document.createElement("a");
      const url = URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
      a.remove();
    };

    downloadGeoJSON(geoJson, "coordinates.geojson");
    navigator.clipboard.writeText(JSON.stringify(geoJson));
  };

  const handleExport = (event) => {
    const value = event.target.value;
    if (value === "KML") {
      exportKML();
    } else if (value === "GeoJSON") {
      exportGeoJSON();
    }
  };

  return (
    <Form.Select style={{backgroundColor:"#3884ff", color:"black"}} size="lg" value={selectedValue} onChange={(e) => {
        // setSelectedValue(e.target.value);
        handleExport(e);
      }}>
        <option  style={{backgroundColor:"#fff"}} value="" disabled  selected>&#x1F4E5; ดาวน์โหลดพิกัด</option>
        <option  style={{backgroundColor:"#fff"}} value="KML">KML</option>
        <option  style={{backgroundColor:"#fff"}} value="GeoJSON">GeoJSON</option>
      </Form.Select>
  );
}

export default ExportKMLButton;
